<script lang="ts" setup>
const title = '会社情報'

const infos = [
  { name: '会社名', text: '株式会社X＆R GLOBAL' },
  { name: '設立日', text: '2023年11月15日' },
  { name: 'CEO', text: '呉 燁彪' },
  { name: 'COO', text: '上田 雄介' },
  { name: '所在地', text: '日本東京都港区南青山2-5-1' },
  {
    name: '事業内容', text: `
    <div>B2B越境調達サービス事業</div>
    <div>ブランドの海外市場進出支援事業</div>
    <div>貿易・物流ソリューション事業</div>
  ` },
]

const partners = 'https://static-jp.theckb.com/static-asset/xr/partner.png'
const partners_h5 = 'https://static-jp.theckb.com/static-asset/xr/partner_h5.png'
</script>

<template>
  <div id="introduce" class=" bg-[#CBE6FF]">
    <ADevice>
      <template #h5>
        <MContainer class=" py-12">
          <MCol class=" gap-6">
            <MText size="h1" class="font-black">{{ title }}</MText>
            <div v-for="v in infos">
              <MText size="lg" class=" font-[900] mb-2">{{ v.name }}</MText>
              <MText size="lg" class=" flex flex-col gap-2" v-html="v.text"></MText>
            </div>
            <div>
              <img :src="partners_h5" alt="">
            </div>
            <MCol class=" gap-2">
              <MText size="md" placement="center">※ お問い合わせフォーム：</MText>
              <a href="#contact">
                <MButtonLinkP1 class=" w-[100%]">
                  お問い合わせ
                </MButtonLinkP1>
              </a>
            </MCol>
          </MCol>
        </MContainer>
      </template>
      <template #pc>
        <AContainer class=" px-[160px] py-[72px]">
          <AText size="h1" placement="left">{{ title }}</AText>
          <div class=" flex items-start gap-[48px] mt-[48px] relative">
            <div class=" grid grid-cols-2 grid-flow-row w-[640px]">
              <div v-for="v in infos" class=" mb-[48px]">
                <MText size="lg" placement="left" class=" font-[900] mb-[8px]">
                  {{ v.name }}
                </MText>
                <MText size="lg" placement="left" v-html="v.text" class=" flex flex-col gap-[8px]">
                </MText>
              </div>
              <MCol class=" gap-[16px]">
                <MText size="md" placement="left">※ お問い合わせフォーム：</MText>
                <a href="#contact">
                  <MButtonLinkP1 class=" w-[280px]">
                    お問い合わせ
                  </MButtonLinkP1>
                </a>
              </MCol>
            </div>
            <div class=" absolute right-0 top-[-102px]">
              <img :src="partners" alt="" class=" w-[432px]">
            </div>
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
